<template>
  <div class="pay_report_page">
    <h1>新用户充值分布报表</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="source"
        placeholder=""
        @change="getMediumListap"
      >
        <el-option
          v-for="(item, itemIndex) in sourceList"
          v-bind:key="itemIndex + 100"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select filterable style="width: 160px" v-model="medium" placeholder="">
        <el-option
          v-for="(item, itemIndex) in mediumList"
          v-bind:key="itemIndex + 100"
          :label="item.rid"
          :value="item.medium"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="dateAry"
        type="daterange"
        range-separator="-"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomTable
          :tableList="tableList"
          :options="tableOptions"
          class="table"
        ></CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from '../../components/CustomTable'
import { datainfor } from '@/utils/formdata.js'

export default {
  components: {
    CustomTable
  },
  data() {
    return {
      // 数组存放开始时间和结束时间
      dateAry: [datainfor(7), datainfor(1)],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      datePicked: [
        this.$store.getters.dateTwoDayBefore,
        this.$store.getters.dateOneDayBefore
      ],
      tableOptions: {
        defaultSort: {
          prop: 'date',
          order: 'ascending'
        },
        theader: [
          {
            name: 'date',
            label: '日期',
            sortable: true,
            fixed: true,
            width: '180px'
          },
          {
            name: 'channel',
            label: '平台',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'dau',
            label: 'dau',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'shareClickCount',
            label: '分享链接点击次数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'newUserCount',
            label: '新增用户',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeUserCount0',
            label: '当日充值人数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeUserCount1',
            label: '次日充值人数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeUserCount2',
            label: '3日充值人数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeUserCount3',
            label: '4日充值人数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeUserCount4',
            label: '5日充值人数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeUserCount5',
            label: '6日充值人数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeUserCount6',
            label: '7日充值人数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'afterRechargeUserCount7',
            label: '7日以后充值人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'rechargeValue0',
            label: '当日充值额度',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeValue1',
            label: '次日充值额度',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeValue2',
            label: '3日充值额度',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeValue3',
            label: '4日充值额度',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeValue4',
            label: '5日充值额度',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeValue5',
            label: '6日充值额度',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeValue6',
            label: '7日充值额度',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'afterRechargeValue7',
            label: '7日以后充值额度',
            sortable: true,
            fix: true,
            width: '180px'
          }
        ]
      },
      tableList: [],
      loading: true,
      source: 'all',
      sourceList: [{ value: 'all' }],
      medium: 'all',
      mediumList: []
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
    this.getsourceList()
    this.getmediumList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    //   获取动态列表
    async getsourceList() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.source_list,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token
        }
      })
      res.data.map(e => {
        this.sourceList.push({ value: e })
      })
    },
    async getMediumListap() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.mediumM_list,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          source: this.source
        }
      })
      this.medium = 'all'
      this.mediumList = []
      this.mediumList = res.data
    },
    //   获取动态列表
    async getmediumList() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.medium_list,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token
        }
      })

      this.mediumList = res.data
    },
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.reports_pay_report,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.dateAry[0],
          end: this.dateAry[1],
          source: this.source,
          medium: this.medium,
          channel: this.curChannel.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
    },
    doInquery() {
      this.getList()
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_download_pay_report +
        '?token=' +
        this.token +
        '&start=' +
        this.dateAry[0] +
        '&end=' +
        this.dateAry[1] +
        '&channel=' +
        this.curChannel.selectValue +
        '&username=' +
        this.username +
        '&source=' +
        this.source +
        '&medium=' +
        this.medium
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.pay_report_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
